import { appData } from '@/mocks/homeData';

export default function AppSection() {
  return (
    <section id="app" className="py-16 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1100px] mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-shrink-0 w-48 md:w-56">
            <div className="relative aspect-[9/16] rounded-2xl overflow-hidden shadow-lg bg-background-200">
              <img
                src={appData.image}
                alt="91电影视频 APP"
                className="w-full h-full object-cover"
                onError={(e) => {
                  const target = e.currentTarget;
                  target.style.display = 'none';
                  (target.parentElement as HTMLElement).style.display = 'none';
                }}
              />
            </div>
          </div>

          <div className="flex-1 text-center lg:text-left">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              {appData.title}
            </h2>
            <p className="mt-2 text-lg font-medium text-primary-500">
              {appData.subtitle}
            </p>
            <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed max-w-[560px] lg:max-w-none">
              {appData.description}
            </p>
            <div className="mt-6 flex flex-wrap gap-2 justify-center lg:justify-start">
              {appData.features.map((f) => (
                <span
                  key={f}
                  className="px-3 py-1.5 rounded-full bg-background-200 text-foreground-700 text-xs font-medium border border-background-300/60 whitespace-nowrap"
                >
                  {f}
                </span>
              ))}
            </div>
            <div className="mt-6 flex items-center gap-4 justify-center lg:justify-start">
              <button className="px-6 py-3 bg-foreground-950 text-background-50 font-medium rounded-md text-sm hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer">
                <i className="ri-apple-fill mr-2"></i>
                iOS 下载
              </button>
              <button className="px-6 py-3 bg-foreground-950 text-background-50 font-medium rounded-md text-sm hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer">
                <i className="ri-android-fill mr-2"></i>
                Android 下载
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}